<template>
    <rkm-modal
        extra-large
        ref="Modal"
        title="Inconsistências"
    >
        <rkm-table
            :fields="fields"
            :items="inconsistencias"
            hide-filters
            hide-pagination
            sort-by="text"
        />

        <template v-slot:footer="{ cancel }">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
export default {
    data: () => ({
        fields: [{ key: 'text', label: 'Descrição', sortable: true }],
        inconsistencias: [],
    }),
    methods: {
        open(inconsistencias) {

            this.inconsistencias = inconsistencias.map(i => ({ text: i.descricao }))

            this.$refs.Modal.show()
        },
    },
}
</script>